// NOTE: in order of the notification hierarchy
var messages = {
  tradeInOnly: 'Add your Kelley Blue Book® Trade-In Value in My Wallet.',
  dealAndTradeIn: 'You have new updates in My Wallet!',
  dealsAndNoTradeIn: 'You have new deal updates in My Wallet!',
  priceChangeFlag: 'The price has changed in your deal.',
  paymentChangeFlag: 'The monthly payment amount has changed in your deal.',
  sellingVehicleChangeFlag: 'The vehicle has changed in your deal.',
  dealTypeChangeFlag: 'The financing option has changed in your deal.',
  creditAppStatusChangeFlag: 'Your credit application status has changed in your deal.',
  // Next steps reminders
  testDrive: 'Waiting to finalize an offer on your dream car?',
  creditApp: 'Save time at the dealership and get pre-approved on your current offer.',
  testDriveAndCreditApp: "Check the progress of your offer and see what's next."
};
export { messages as default };
